
// This file is generated. Don't modify it.
import React from 'react'
export default function PhoneWireFrameIcon (props) {

    const { color } = props
    
    return (
                
        <svg width="1em" height="1em" viewBox="0 0 16 16">
            <defs>
                <path d="M5,10.0158691 L11,10.0158691 L11,3 L5,3 L5,10.0158691 Z M5,11.0158691 L5,13 L11,13 L11,11.0158691 L5,11.0158691 Z M5,2 L11,2 C11.5522847,2 12,2.44771525 12,3 L12,13 C12,13.5522847 11.5522847,14 11,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M8,12.5023804 C7.72385763,12.5023804 7.5,12.2785227 7.5,12.0023804 C7.5,11.726238 7.72385763,11.5023804 8,11.5023804 C8.27614237,11.5023804 8.5,11.726238 8.5,12.0023804 C8.5,12.2785227 8.27614237,12.5023804 8,12.5023804 Z" id="PhoneWireFrameIcon-path-1"></path>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icon/Wireframe/Phone">
                    <g id="Group">
                        <rect id="16px-Bounding-Box" stroke="none" fill="none" fillRule="nonzero" x="0.5" y="0.5" width="15" height="15"></rect>
                        <mask id="PhoneWireFrameIcon-mask-2" fill="white">
                            <use href="#PhoneWireFrameIcon-path-1"></use>
                        </mask>
                        <use id="Mask" fill={color} fillRule="nonzero" href="#PhoneWireFrameIcon-path-1"></use>
                    </g>
                </g>
            </g>
        </svg>
    )
}
